// @ts-expect-error
import {getWidthOfText} from '@pb/kit-util-get-width-of-text';

type ContainerStyles = {
    width: number,
    fontSize?: number,
    fontWeight?: string,
    letterSpacing?: number,
};

interface CutTextPerLinesProps {
    styles: ContainerStyles,
    text: string,
    lines: number,
}

interface TruncateResult {
    slicedText: string,
    isEllipsis: boolean,
}

const getTextWidth = (styles: ContainerStyles, text: string) => {
    const {fontSize, fontWeight, letterSpacing} = styles;
    return Math.ceil(getWidthOfText(text, {fontWeight, fontSize, letterSpacing}));
};

const sliceWordToMatchLineWidth = (styles: ContainerStyles, text: string) => {
    let slicedWidth;

    do {
        text = text.slice(0, -1).trim();
        slicedWidth = getTextWidth(styles, text);
    } while (slicedWidth > Math.floor(styles.width));

    return text.slice(0, -3).concat('...');
};

export const cutTextPerLines = ({styles, text, lines}: CutTextPerLinesProps): TruncateResult => {
    const containerWidth = Math.floor(styles.width);
    const lineList = new Array(lines).toString().split(',');

    let lineIndex = 0;
    let isEllipsis = false;
    text.split(' ').forEach(word => {
        if (lineIndex < lines) {
            const currentLine = lineList[lineIndex];
            const wordWithSpace = currentLine.length > 0 ? ` ${word}` : word;

            if (getTextWidth(styles, currentLine + wordWithSpace) < containerWidth) {
                lineList[lineIndex] += wordWithSpace;
            } else if (lineIndex + 1 >= lines) {
                lineList[lineIndex++] = sliceWordToMatchLineWidth(styles, currentLine + wordWithSpace);
                isEllipsis = true;
            } else if (getTextWidth(styles, wordWithSpace) >= containerWidth) {
                let insertLine = lineIndex;
                let insertWord = wordWithSpace;

                if (currentLine.length !== 0) {
                    insertLine++;
                    insertWord = word;
                }

                lineList[insertLine] = sliceWordToMatchLineWidth(styles, insertWord);
                lineIndex = insertLine + 1;
                isEllipsis = true;
            } else {
                lineList[++lineIndex] += word;
            }
        }
    });

    return ({slicedText: lineList.join(' '), isEllipsis});
};
